const API_BASE = process.env.REACT_APP_THANE_API || 'http://localhost:8200';

export const ENDPOINTS = {
  HEALTH: `${API_BASE}/health`,
  DISCOVER: `${API_BASE}/v1/discover`,
  PROVIDER: (wallet) => `${API_BASE}/v1/providers/${wallet}`,
  PROVIDER_REPUTATION: (wallet) => `${API_BASE}/v1/providers/${wallet}/reputation`,
  PROVIDER_MONITORING: (wallet) => `${API_BASE}/v1/monitoring/provider/${wallet}`,
  PROTOCOL_STATS: `${API_BASE}/v1/protocol/stats`,
  BURN_TRACKER: `${API_BASE}/v1/protocol/burn-tracker`,
  LEADERBOARD: `${API_BASE}/v1/protocol/leaderboard`,
  MONITORING_LATEST: `${API_BASE}/v1/monitoring/latest`,

  // Fiat — Provider onboarding
  FIAT_PROVIDER_SIGNUP: `${API_BASE}/v1/fiat/providers/signup`,
  FIAT_PROVIDER_LOGIN: `${API_BASE}/v1/fiat/providers/login`,
  FIAT_PROVIDER_ME: `${API_BASE}/v1/fiat/providers/me`,
  FIAT_PROVIDER_STAKE: `${API_BASE}/v1/fiat/providers/stake`,
  FIAT_PROVIDER_EARNINGS: `${API_BASE}/v1/fiat/providers/earnings`,
  FIAT_PROVIDER_WITHDRAW: `${API_BASE}/v1/fiat/providers/withdraw`,

  // Fiat — Agent onboarding
  FIAT_AGENT_SIGNUP: `${API_BASE}/v1/fiat/agents/signup`,
  FIAT_AGENT_LOGIN: `${API_BASE}/v1/fiat/agents/login`,
  FIAT_AGENT_ME: `${API_BASE}/v1/fiat/agents/me`,
  FIAT_AGENT_DEPOSIT: `${API_BASE}/v1/fiat/agents/deposit`,
  FIAT_AGENT_BALANCE: `${API_BASE}/v1/fiat/agents/balance`,
  FIAT_AGENT_REGEN_KEY: `${API_BASE}/v1/fiat/agents/regenerate-key`,
};

export default API_BASE;
